if (!customElements.get("price-normalize")) {
    class PriceNormalize extends HTMLElement {
        static get observedAttributes() {
            return ["data-compare-at-price", "data-pristine-price", "data-timestamp"];
        }
        constructor() {
            super();
            this.discountCodesStoraged = null;
            this.giftCardAllowList = null;
            this.conditionsValues = {
                hasAppliedDiscountCode: false,
                hasMarkdown: false,
                isDiscountCodeAppliedValidForProduct: false,
                isCashbackDiscountCode: false,
                isPointsDiscountCode: false,
                isPixDiscountCodeActive: false,
                isKit: false,
                isHomogeneousKit: false
            };
            this.toLogger = false;
            this.PriceNormalizeResolveType = window.PriceNormalizeResolveType || (() => undefined);
            this.toLogger = sessionStorage.getItem('insider:debug:price-normalize') === 'true' ? true : false;
            this.init();
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (!!oldValue) {
                if (name === "data-timestamp") {
                    this.log("[attributeChangedCallback]", " fired by:", this.dataset.timestamp.split("-")[0]);
                    this.init();
                }
            }
        }
        log(...args) {
            if (this.toLogger)
                console.log("%c[DEBUG]", "color:red;", `[ProductID: ${this.dataset.productId}]`, ...args);
        }
        getDiscountCodeStoraged() {
            this.log("getDiscountCodeStoraged");
            const handlePromotionCouponReady = () => {
                const data = sessionStorage.getItem('insider:cart:promotionCoupon');
                if (data)
                    this.discountCodesStoraged = JSON.parse(data);
            };
            handlePromotionCouponReady();
            window.addEventListener('PromotionCouponReady', () => {
                this.dataset.timestamp = `priceNormalize:getDiscountCodeStoraged:PromotionCouponReady-${new Date().toISOString()}`;
                handlePromotionCouponReady();
                this.init();
            });
        }
        getGiftCardAllowList() {
            const data = JSON.parse(document.querySelector("script[type='application/json']#giftcardDiscountAllowList").innerHTML);
            this.giftCardAllowList = Object.assign(Object.assign({}, data), { codes: data.codes.split(",").filter(Boolean) });
        }
        init() {
            if (this.parentElement === null)
                return;
            this.log("PriceNormalize initialized");
            this.getDiscountCodeStoraged();
            // this.getGiftCardAllowList()
            this.setPriceConditions();
            const resolvedType = this.PriceNormalizeResolveType(this.conditionsValues);
            const priceObject = this.createPriceObject(resolvedType);
            this.renderPrices(priceObject);
        }
        createPriceObject(type) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
            this.log("Creating price object with type:", type);
            let discountValue, discountCode;
            const partnerDiscountType = (_b = (_a = this.discountCodesStoraged) === null || _a === void 0 ? void 0 : _a.discount_config) === null || _b === void 0 ? void 0 : _b.type;
            const hasOtherDiscountCode = (_c = this.discountCodesStoraged) === null || _c === void 0 ? void 0 : _c.code;
            const productCollections = ((_e = (_d = this.dataset) === null || _d === void 0 ? void 0 : _d.productCollections) === null || _e === void 0 ? void 0 : _e.split(",").map(Number)) || [];
            const productId = Number((_f = this.dataset) === null || _f === void 0 ? void 0 : _f.productId);
            // Função para validar se o desconto é aplicável ao produto/coleção
            const isDiscountValid = (discountSource) => {
                var _a, _b, _c, _d;
                if (!discountSource)
                    return false;
                if (((_a = discountSource === null || discountSource === void 0 ? void 0 : discountSource.discount) === null || _a === void 0 ? void 0 : _a.allocation_method) === "across")
                    return true;
                if (((_b = discountSource === null || discountSource === void 0 ? void 0 : discountSource.discount) === null || _b === void 0 ? void 0 : _b.allocation_method) === "each") {
                    const collections = ((_c = discountSource === null || discountSource === void 0 ? void 0 : discountSource.discount) === null || _c === void 0 ? void 0 : _c.entitled_collection_ids) || [];
                    const products = ((_d = discountSource === null || discountSource === void 0 ? void 0 : discountSource.discount) === null || _d === void 0 ? void 0 : _d.entitled_product_ids) || [];
                    return collections.some(id => productCollections.includes(id)) || products.includes(productId);
                }
                return false;
            };
            // Define o desconto e código a serem aplicados
            if (hasOtherDiscountCode && isDiscountValid((_g = this.discountCodesStoraged) === null || _g === void 0 ? void 0 : _g.data)) {
                discountValue = (_k = (_j = (_h = this.discountCodesStoraged) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.discount) === null || _k === void 0 ? void 0 : _k.value;
                discountCode = (_l = this.discountCodesStoraged) === null || _l === void 0 ? void 0 : _l.code;
            }
            else {
                discountValue = (_p = (_o = (_m = this.discountCodesStoraged) === null || _m === void 0 ? void 0 : _m.discount_default) === null || _o === void 0 ? void 0 : _o.discount) === null || _p === void 0 ? void 0 : _p.value;
                discountCode = (_s = (_r = (_q = this.discountCodesStoraged) === null || _q === void 0 ? void 0 : _q.discount_default) === null || _r === void 0 ? void 0 : _r.discount) === null || _s === void 0 ? void 0 : _s.code;
            }
            // Demais configurações de desconto
            const discountType = ((_v = (_u = (_t = this.discountCodesStoraged) === null || _t === void 0 ? void 0 : _t.discount_default) === null || _u === void 0 ? void 0 : _u.discount) === null || _v === void 0 ? void 0 : _v.value_type) || partnerDiscountType;
            const partnerDiscountCode = (_w = this.discountCodesStoraged) === null || _w === void 0 ? void 0 : _w.code;
            const discountConfigMultiplier = (_y = (_x = this.discountCodesStoraged) === null || _x === void 0 ? void 0 : _x.discount_config) === null || _y === void 0 ? void 0 : _y.multiplier;
            const discountConfigMultiplierClub = (_0 = (_z = this.discountCodesStoraged) === null || _z === void 0 ? void 0 : _z.discount_config) === null || _0 === void 0 ? void 0 : _0.multiplier_club;
            const discountConfigTextGrup1 = (_2 = (_1 = this.discountCodesStoraged) === null || _1 === void 0 ? void 0 : _1.discount_config) === null || _2 === void 0 ? void 0 : _2.text_grup_1;
            const discountConfigTextGrup2 = (_4 = (_3 = this.discountCodesStoraged) === null || _3 === void 0 ? void 0 : _3.discount_config) === null || _4 === void 0 ? void 0 : _4.text_grup_2;
            const kitUpsell = Array.from({ length: 3 }, (_, i) => {
                const index = i + 1;
                return {
                    [`product${index}Id`]: this.getAttribute(`data-upsell-product-${index}-id`),
                    [`kitUnitPrice`]: this.getAttribute(`data-upsell-product-${index}-price`),
                    [`kitUnitFinalPrice`]: this.getAttribute(`data-upsell-product-${index}-kit-final-price`),
                    [`kitUnitCompareAtPrice`]: this.getAttribute(`data-upsell-product-${index}-compare-at-price`),
                    [`kitUnitTitle`]: this.getAttribute(`data-upsell-product-${index}-title`),
                    [`kitUnitPriceWithPixDiscount`]: this.calculatePrice(Number(this.getAttribute(`data-upsell-product-${index}-price`)), Math.abs(Number(this.dataset.pixDiscountValue))),
                    [`kitUnitPriceWithDiscountCode`]: this.calculatePrice(Number(this.getAttribute(`data-upsell-product-${index}-price`)), Math.abs(Number(discountValue))),
                    [`kitUnitPriceWithDiscountCodeAndPixDiscount`]: this.calculatePrice(this.calculatePrice(Number(this.getAttribute(`data-upsell-product-${index}-price`)), Math.abs(Number(discountValue))), Math.abs(Number(this.dataset.pixDiscountValue)))
                };
            });
            const priceObject = {
                placement: this.dataset.placement,
                type: type,
                productId: this.dataset.productId,
                discountValue: Math.abs(Number(discountValue)) || 0,
                discountCode: discountCode || partnerDiscountCode,
                discountType: discountType,
                partnerDiscountCode: partnerDiscountCode,
                partnerDiscountType: partnerDiscountType,
                messageColor: this.dataset.messageColor || null,
                compareAtPrice: this.dataset.compareAtPrice ? this.formatMoney(Number(this.dataset.compareAtPrice)) : null,
                price: this.dataset.pristinePrice ? this.formatMoney(Number(this.dataset.pristinePrice)) : null,
                priceVaries: this.dataset.priceVaries === "true" ? true : false,
                priceWithDiscountCode: this.formatMoney(this.calculatePrice(Number(this.dataset.pristinePrice), Math.abs(Number(discountValue)))),
                priceWithPixDiscount: this.formatMoney(this.calculatePrice(Number(this.dataset.pristinePrice), Math.abs(Number(this.dataset.pixDiscountValue)))),
                priceWithDiscountCodeAndPixDiscount: this.formatMoney(this.calculatePrice(this.calculatePrice(Number(this.dataset.pristinePrice), Math.abs(Number(discountValue))), Math.abs(Number(this.dataset.pixDiscountValue)))),
                isKit: ((_5 = this.dataset) === null || _5 === void 0 ? void 0 : _5.kitProducts) === "true" ? true : false,
                isHomogeneousKit: Number((_6 = this.dataset) === null || _6 === void 0 ? void 0 : _6.kitItemCount) === 1 ? true : false,
                kitQuantity: this.dataset.kitItemQuantity ? Number(this.dataset.kitItemQuantity) : undefined,
                kitCompareAtPrice: this.formatMoney((Number(this.dataset.compareAtPrice))),
                kitUnitCompareAtPrice: this.formatMoney((Number(this.dataset.compareAtPrice) / Number(this.dataset.kitItemQuantity))),
                kitFinalPrice: this.formatMoney((Number(this.dataset.kitFinalPrice) * 100)),
                kitFinalPriceWithPixDiscount: this.formatMoney(this.calculatePrice((Number(this.dataset.kitFinalPrice) * 100), Math.abs(Number(this.dataset.pixDiscountValue)))),
                kitFinalPriceWithDiscountCode: this.formatMoney(this.calculatePrice(Number(this.dataset.kitFinalPrice) * 100, Math.abs(Number(discountValue)))),
                kitFinalPriceWithDiscountCodeAndPixDiscount: this.formatMoney(this.calculatePrice(this.calculatePrice(Number(this.dataset.kitFinalPrice) * 100, Math.abs(Number(discountValue))), Math.abs(Number(this.dataset.pixDiscountValue)))),
                kitUnitPrice: this.formatMoney((Number(this.dataset.kitFinalPrice) * 100) / Number(this.dataset.kitItemQuantity)),
                kitUnitPriceWithPixDiscount: this.formatMoney(this.calculatePrice((Number(this.dataset.kitFinalPrice) * 100) / Number(this.dataset.kitItemQuantity), Math.abs(Number(this.dataset.pixDiscountValue)))),
                kitUnitPriceWithDiscountCode: this.formatMoney(this.calculatePrice(Number(this.dataset.kitFinalPrice) * 100 / Number(this.dataset.kitItemQuantity), Math.abs(Number(discountValue)))),
                kitUnitPriceWithDiscountCodeAndPixDiscount: this.formatMoney(this.calculatePrice(this.calculatePrice(Number(this.dataset.kitFinalPrice) * 100 / Number(this.dataset.kitItemQuantity), Math.abs(Number(discountValue))), Math.abs(Number(this.dataset.pixDiscountValue)))),
                pointsGroups: [
                    {
                        multiplier: discountConfigMultiplier,
                        multiplierClub: discountConfigMultiplierClub,
                        textGroup1: discountConfigTextGrup1,
                        textGroup2: discountConfigTextGrup2,
                    }
                ],
                kitUpsell: kitUpsell
            };
            this.log("Price Object:", priceObject);
            return priceObject;
        }
        calculatePrice(price, discount) {
            const finalPrice = price * (1 - discount / 100);
            return finalPrice;
        }
        formatMoney(price) {
            const value = Math.round(price / 100);
            if (Number.isNaN(value))
                return undefined;
            const priceDisplay = ` R$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
            return priceDisplay;
        }
        setPriceConditions() {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
            this.log("setPriceConditions");
            const partnerDiscountType = (_b = (_a = this.discountCodesStoraged) === null || _a === void 0 ? void 0 : _a.discount_config) === null || _b === void 0 ? void 0 : _b.type;
            const productId = Number((_c = this.dataset) === null || _c === void 0 ? void 0 : _c.productId);
            const productCollections = ((_e = (_d = this.dataset) === null || _d === void 0 ? void 0 : _d.productCollections) === null || _e === void 0 ? void 0 : _e.split(",").map(Number)) || [];
            const isToShowCouponDiscount = ((_f = this.dataset) === null || _f === void 0 ? void 0 : _f.isToShowCouponDiscount) ? JSON.parse(this.dataset.isToShowCouponDiscount) : false;
            const hasDefaultDiscountCode = (_g = this.discountCodesStoraged) === null || _g === void 0 ? void 0 : _g.discount_default;
            const hasOtherDiscountCode = (_h = this.discountCodesStoraged) === null || _h === void 0 ? void 0 : _h.code;
            let hasAppliedDiscountCode = false;
            // Função auxiliar para verificar se um desconto é válido para o produto
            const isDiscountValid = (discountSource) => {
                var _a, _b, _c, _d;
                if (!discountSource)
                    return false;
                if (((_a = discountSource === null || discountSource === void 0 ? void 0 : discountSource.discount) === null || _a === void 0 ? void 0 : _a.allocation_method) === "across")
                    return true;
                if (((_b = discountSource === null || discountSource === void 0 ? void 0 : discountSource.discount) === null || _b === void 0 ? void 0 : _b.allocation_method) === "each") {
                    const collections = ((_c = discountSource === null || discountSource === void 0 ? void 0 : discountSource.discount) === null || _c === void 0 ? void 0 : _c.entitled_collection_ids) || [];
                    const products = ((_d = discountSource === null || discountSource === void 0 ? void 0 : discountSource.discount) === null || _d === void 0 ? void 0 : _d.entitled_product_ids) || [];
                    return (collections.some(id => productCollections.includes(id)) || products.includes(productId));
                }
                return false;
            };
            // Verifica primeiro desconto do usuário, depois o desconto padrão
            if (hasOtherDiscountCode && isDiscountValid((_j = this.discountCodesStoraged) === null || _j === void 0 ? void 0 : _j.data) && isToShowCouponDiscount) {
                this.log("Discount code applied:", (_k = this.discountCodesStoraged) === null || _k === void 0 ? void 0 : _k.code);
                hasAppliedDiscountCode = true;
            }
            else if (hasDefaultDiscountCode && isDiscountValid((_l = this.discountCodesStoraged) === null || _l === void 0 ? void 0 : _l.discount_default) && isToShowCouponDiscount) {
                this.log("Discount code applied 2:", (_m = this.discountCodesStoraged) === null || _m === void 0 ? void 0 : _m.discount_default);
                hasAppliedDiscountCode = true;
            }
            // Regras que desativam o desconto
            if (["points", "cashback"].includes(partnerDiscountType)) {
                hasAppliedDiscountCode = false;
            }
            if (hasOtherDiscountCode && ((_q = (_p = (_o = this.discountCodesStoraged) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p.discount) === null || _q === void 0 ? void 0 : _q.value_type) !== "percentage") {
                hasAppliedDiscountCode = false;
            }
            {
                this.conditionsValues = {
                    hideDefaultMessage: (_r = this.discountCodesStoraged) === null || _r === void 0 ? void 0 : _r.disable_default_message,
                    hasAppliedDiscountCode: hasAppliedDiscountCode,
                    hasMarkdown: Number((_s = this.dataset) === null || _s === void 0 ? void 0 : _s.compareAtPrice) > Number((_t = this.dataset) === null || _t === void 0 ? void 0 : _t.pristinePrice),
                    isDiscountCodeAppliedValidForProduct: !!((_x = (_w = (_v = (_u = this.discountCodesStoraged) === null || _u === void 0 ? void 0 : _u.data) === null || _v === void 0 ? void 0 : _v.discount) === null || _w === void 0 ? void 0 : _w.entitled_product_ids) === null || _x === void 0 ? void 0 : _x.includes(Number(this.dataset.productId))),
                    isCashbackDiscountCode: partnerDiscountType === "cashback" ? true : false,
                    isPointsDiscountCode: partnerDiscountType === "points" ? true : false,
                    isPixDiscountCodeActive: this.dataset.pixEnable === "true" && this.dataset.pixShowing === "true",
                    isKit: !!((_y = this.dataset) === null || _y === void 0 ? void 0 : _y.kitProducts),
                    isHomogeneousKit: Number((_z = this.dataset) === null || _z === void 0 ? void 0 : _z.kitItemCount) === 1 ? true : false,
                };
            }
        }
        changePriceCouponKit(price, evt) {
            var _a, _b, _c, _d, _e, _f;
            const kitContainer = evt.querySelector(".container-discount-kit-element");
            if (kitContainer) {
                const kitContainerPrice = kitContainer.querySelector(".price");
                if (kitContainerPrice)
                    kitContainerPrice === null || kitContainerPrice === void 0 ? void 0 : kitContainerPrice.remove();
                let discountValue = ((_c = (_b = (_a = this.discountCodesStoraged) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.discount) === null || _c === void 0 ? void 0 : _c.value) || ((_f = (_e = (_d = this.discountCodesStoraged) === null || _d === void 0 ? void 0 : _d.discount_default) === null || _e === void 0 ? void 0 : _e.discount) === null || _f === void 0 ? void 0 : _f.value);
                kitContainer.prepend(this.createPriceElement(this.formatMoney(this.calculatePrice(price, Math.abs(Number(discountValue)))), "coupon-price"));
            }
        }
        createPriceElement(price, extraClass) {
            this.log("createPriceElement", price, extraClass);
            const container = document.createElement('span');
            container.className = extraClass ? `init-price ${extraClass}` : 'init-price';
            container.textContent = price;
            return container;
        }
        createPixCouponElement(price) {
            this.log("createPixCouponElement", price);
            const container = document.createElement('span');
            container.className = 'pix-price';
            const prefixText = document.createTextNode(' (no pix ');
            const valueSpan = document.createElement('span');
            valueSpan.className = 'pix-price-value';
            valueSpan.textContent = price;
            const closingText = document.createTextNode(')');
            container.appendChild(prefixText);
            container.appendChild(valueSpan);
            container.appendChild(closingText);
            return container;
        }
        createPriceMarkdownElement(price) {
            this.log("createPriceMarkdownElement", price);
            const container = document.createElement("span");
            container.className = "markdown-price";
            container.textContent = price;
            return container;
        }
        createCouponElement(couponCode) {
            this.log("createCouponElement", couponCode);
            const container = document.createElement("span");
            container.className = "coupon-code-message";
            const prefixText = document.createTextNode(' com cupom ');
            const valueSpan = document.createElement('span');
            valueSpan.className = 'coupon-code';
            valueSpan.textContent = couponCode;
            container.appendChild(prefixText);
            container.appendChild(valueSpan);
            return container;
        }
        createPointsElement(priceObject) {
            var _a, _b, _c;
            this.log("createPointsElement");
            // Remove existing points container if present
            const pointsContainerSelect = (_a = this.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(".points-container");
            if (pointsContainerSelect)
                pointsContainerSelect === null || pointsContainerSelect === void 0 ? void 0 : pointsContainerSelect.remove();
            // Main container
            const pointsContainer = document.createElement("div");
            pointsContainer.classList.add("points-container");
            pointsContainer.id = "partners-points-container";
            // Points text with coupon code
            const pointsText = document.createElement("span");
            pointsText.classList.add("points-text");
            pointsText.textContent = `Cliente ${priceObject.partnerDiscountCode} ganha pontos com o cupom `;
            const couponCodeSpan = document.createElement("span");
            couponCodeSpan.textContent = priceObject.partnerDiscountCode;
            couponCodeSpan.classList.add("coupon-code");
            pointsText.appendChild(couponCodeSpan);
            // Club block with points details
            const clubBlock = document.createElement("div");
            clubBlock.classList.add("club-block");
            const price = Number((_b = priceObject.price) === null || _b === void 0 ? void 0 : _b.replace("R$", ""));
            const group = priceObject.pointsGroups[0];
            const points1 = group.multiplier * price;
            const points2 = group.multiplierClub * price;
            const itemClub1 = document.createElement("div");
            itemClub1.textContent = `${group.textGroup1}: `;
            const point1 = document.createElement("span");
            point1.textContent = `${points1} pontos`;
            itemClub1.appendChild(point1);
            const itemClub2 = document.createElement("div");
            itemClub2.textContent = `${group.textGroup2}: `;
            const point2 = document.createElement("span");
            point2.textContent = `${points2} pontos`;
            itemClub2.appendChild(point2);
            // Add clubs to club block (order preserved)
            clubBlock.append(itemClub2, itemClub1);
            pointsContainer.append(pointsText, clubBlock);
            // Insert into DOM based on placement
            const isCard = priceObject.placement === "card";
            const isPdpDesk = priceObject.placement === "pdp-desk";
            const isPdpMob = priceObject.placement === "pdp-mob" && window.innerWidth < 750;
            const isPdk = priceObject.placement === "pdk";
            if (isCard) {
                const productCardColorSelector = this.parentElement.querySelector("product-card-color-selector");
                if (productCardColorSelector)
                    productCardColorSelector === null || productCardColorSelector === void 0 ? void 0 : productCardColorSelector.after(pointsContainer);
            }
            else if (isPdpDesk) {
                this.after(pointsContainer);
            }
            else if (isPdpMob) {
                const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".Product__InfoWrapper");
                (_c = mediaWrapper === null || mediaWrapper === void 0 ? void 0 : mediaWrapper.querySelector(".points-container")) === null || _c === void 0 ? void 0 : _c.remove();
                pointsContainer.style.marginBottom = "8px";
                if (mediaWrapper)
                    mediaWrapper.prepend(pointsContainer);
            }
            else if (isPdk) {
                this.parentElement.appendChild(pointsContainer);
            }
        }
        createCashbackElement(priceObject) {
            var _a;
            this.log("createCashbackElement");
            const cashbackContainerSelect = this.parentElement.querySelector(".cashback-container");
            if (cashbackContainerSelect)
                cashbackContainerSelect === null || cashbackContainerSelect === void 0 ? void 0 : cashbackContainerSelect.remove();
            const cashbackContainer = document.createElement("div");
            cashbackContainer.classList.add("cashback-container");
            cashbackContainer.id = "partners-cashback-container";
            const cashbackText = document.createElement("span");
            const price = Number(priceObject.price.replace("R$", ""));
            const multiplier = priceObject.pointsGroups[0].multiplier;
            const cashbackValue = this.formatMoney(multiplier * price);
            const couponCodeSpan = document.createElement("span");
            couponCodeSpan.textContent = priceObject.partnerDiscountCode;
            couponCodeSpan.classList.add("coupon-code");
            cashbackText.textContent = `${cashbackValue} de cashback com cupom `;
            cashbackText.appendChild(couponCodeSpan);
            cashbackContainer.appendChild(cashbackText);
            // Inserção no DOM com base no placement
            const isCard = priceObject.placement === "card";
            const isPdpDesk = priceObject.placement === "pdp-desk";
            const isPdpMob = priceObject.placement === "pdp-mob" && window.innerWidth < 750;
            const isPdk = priceObject.placement === "pdk";
            if (isCard) {
                const productCardColorSelector = this.parentElement.querySelector("product-card-color-selector");
                if (productCardColorSelector)
                    productCardColorSelector === null || productCardColorSelector === void 0 ? void 0 : productCardColorSelector.after(cashbackContainer);
            }
            else if (isPdpDesk) {
                this.after(cashbackContainer);
            }
            else if (isPdpMob) {
                const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".Product__InfoWrapper");
                (_a = mediaWrapper === null || mediaWrapper === void 0 ? void 0 : mediaWrapper.querySelector(".cashback-container")) === null || _a === void 0 ? void 0 : _a.remove();
                cashbackContainer.style.marginBottom = "8px";
                if (mediaWrapper)
                    mediaWrapper.prepend(cashbackContainer);
            }
            else if (isPdk) {
                this.parentElement.appendChild(cashbackContainer);
            }
        }
        setDiscountFlagElement(compareAtPrice, price, placement = this.dataset.placement) {
            this.log("setDiscountFlagElement", compareAtPrice, price, placement);
            const compareAtPriceValue = Number(compareAtPrice.replace("R$", "").replace(/\./g, "").replace(",", "."));
            const priceValue = Number(price.replace("R$", "").replace(/\./g, "").replace(",", "."));
            const discountPercentage = Math.round(((compareAtPriceValue - priceValue) / compareAtPriceValue) * 100);
            const labelsProductDetail = document.createElement("div");
            labelsProductDetail.classList.add("labels-product-detail");
            const productItemLabelList = document.createElement("div");
            if (compareAtPriceValue > priceValue) {
                productItemLabelList.id = "automatic-flag-label-detail-element";
                productItemLabelList.classList.add("ProductItem__LabelList", "custom-labels", "custom-top-right");
                const productItemLabel = document.createElement("span");
                productItemLabel.classList.add("ProductItem__Label", "Heading", "Text--subdued");
                productItemLabel.textContent = `${discountPercentage}% OFF`;
                productItemLabelList.appendChild(productItemLabel);
                labelsProductDetail.appendChild(productItemLabelList);
            }
            // Insert into DOM based on placement
            const isCard = placement === "card";
            const isPdpDesk = placement === "pdp-desk";
            const isPdpMob = placement === "pdp-mob" && window.innerWidth < 750;
            const isPdk = placement === "pdk";
            if (isCard) {
                const flag = this.parentElement.parentElement.parentElement.parentElement.querySelector("#automatic-flag-label-detail-element");
                const label = this.parentElement.parentElement.parentElement.parentElement.querySelector(".labels-products");
                if (flag)
                    flag === null || flag === void 0 ? void 0 : flag.parentElement.remove();
                if (label)
                    label === null || label === void 0 ? void 0 : label.append(labelsProductDetail);
            }
            else if (isPdpDesk) {
                const flag = this.parentElement.parentElement.querySelector("#automatic-flag-label-detail-element");
                const label = this.parentElement.parentElement.querySelector(".labels-products");
                if (flag)
                    flag === null || flag === void 0 ? void 0 : flag.parentElement.remove();
                if (label)
                    label === null || label === void 0 ? void 0 : label.append(labelsProductDetail);
            }
            else if (isPdpMob) {
                const flag = this.parentElement.parentElement.parentElement.parentElement.querySelector("#automatic-flag-label-detail-element");
                const label = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-info-mobile--labels-products");
                if (flag)
                    flag.parentElement.remove();
                if (label)
                    label === null || label === void 0 ? void 0 : label.append(labelsProductDetail);
            }
            else if (isPdk) {
                const contentLabels = labelsProductDetail.innerHTML;
                const flag = this.parentElement.parentElement.querySelector("#automatic-flag-label-detail-element");
                const label = document.querySelectorAll(".labels-products");
                if (flag)
                    flag === null || flag === void 0 ? void 0 : flag.parentElement.remove();
                label.forEach(element => {
                    const target = element.querySelector(".labels-product-detail");
                    if (target) {
                        target.innerHTML = contentLabels;
                    }
                    else {
                        const newNode = document.createElement("div");
                        newNode.classList.add("labels-product-detail");
                        newNode.innerHTML = contentLabels;
                        element.appendChild(newNode);
                    }
                });
            }
        }
        findSelectedProduct(kitUpsell, selectedProductId) {
            this.log("findSelectedProduct", kitUpsell, selectedProductId);
            return kitUpsell.find((product) => {
                const values = Object.values(product);
                return values.includes(selectedProductId);
            });
        }
        renderPrices(priceObject) {
            this.log("renderPrices");
            let priceContainer = this.querySelector(".price-container");
            if (!priceContainer) {
                priceContainer = document.createElement("div");
                priceContainer.classList.add("price-container");
            }
            else {
                // Reutiliza o container existente limpando o conteúdo
                priceContainer.innerHTML = "";
            }
            // Show "A partir de" if isKit or the current variant is the minimum price
            const isMinVariant = priceObject.priceVaries === true &&
                this.dataset.pristinePrice &&
                this.dataset.minPrice &&
                Number(this.dataset.pristinePrice) === Number(this.dataset.minPrice);
            if (priceObject.isKit || isMinVariant) {
                const varies = document.createElement("span");
                varies.classList.add("price-varies");
                varies.textContent = "A partir de ";
                priceContainer.appendChild(varies);
            }
            // if (priceObject.kitUpsell && priceObject.kitUpsell.length > 0 && priceObject.placement !== "card") {
            //   const selectKitUpsellContainer = document.querySelector("cupom-kits-upsell");
            //   const kitUpsell = priceObject.kitUpsell;
            //   if (selectKitUpsellContainer) {
            //     const upsellButtons = selectKitUpsellContainer.querySelectorAll(".upsell-kits__button");
            //     upsellButtons.forEach((button) => {
            //       const selectedProduct = this.findSelectedProduct(kitUpsell, button.getAttribute("data-upsell-kits-product-id"))
            //       const upsellQuantity = Number(button.querySelector("a").textContent.trim().replace(/[^0-9\.]+/g, ""));
            //       if(upsellQuantity === 1) {
            //         button.querySelector(".discounted-price").textContent = selectedProduct ? this.formatMoney(selectedProduct.kitUnitPrice * 100) + "/un" : "";
            //       } else {
            //         button.querySelector(".discounted-price").textContent = selectedProduct ? this.formatMoney(selectedProduct.kitUnitFinalPrice * 100 / upsellQuantity) + "/un" : "";
            //       }
            //     })
            //   }
            // }
            if (priceObject.type.includes("Points")) {
                this.createPointsElement(priceObject);
            }
            if (priceObject.type.includes("Cashback")) {
                this.createCashbackElement(priceObject);
            }
            const isCard = priceObject.placement === "card";
            const isPdpDesk = priceObject.placement === "pdp-desk";
            const isPdpMob = priceObject.placement === "pdp-mob" && window.innerWidth < 750;
            const isPdk = priceObject.placement === "pdk";
            switch (priceObject.type) {
                case "OnlyPrice":
                case "PriceWithPoints":
                case "PriceWithCashback":
                    this.dataset.type = "OnlyPrice";
                    priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
                    this.appendChild(priceContainer);
                    break;
                case "PriceWithPix":
                case "PriceWithPointsAndPix":
                case "PriceWithCashbackAndPix":
                    this.dataset.type = "PriceWithPix";
                    priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
                    priceContainer.appendChild(this.createPixCouponElement(priceObject.priceWithPixDiscount));
                    this.appendChild(priceContainer);
                    break;
                case "PriceWithDiscountCode":
                    this.dataset.type = "PriceWithDiscountCode";
                    this.setDiscountFlagElement(priceObject.price, priceObject.priceWithDiscountCode, priceObject.placement);
                    if (priceObject.placement !== "card") {
                        priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
                    }
                    else {
                        priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.price));
                    }
                    priceContainer.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                    priceContainer.appendChild(this.createCouponElement(priceObject.discountCode));
                    if (isPdpMob) {
                        this.appendChild(priceContainer);
                        const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product__media-wrapper");
                        if (mediaWrapper) {
                            const priceWithDiscountCode = document.createElement("span");
                            priceWithDiscountCode.className = "price-with-discount-code";
                            priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                            priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                            priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                            const priceWithDiscountCodeEl = mediaWrapper.querySelector(".price-with-discount-code");
                            if (priceWithDiscountCodeEl)
                                priceWithDiscountCodeEl === null || priceWithDiscountCodeEl === void 0 ? void 0 : priceWithDiscountCodeEl.remove();
                            mediaWrapper.appendChild(priceWithDiscountCode);
                        }
                        const floatingButton = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-form__buttons-floating");
                        if (floatingButton) {
                            const priceWithDiscountCode = document.createElement("span");
                            priceWithDiscountCode.className = "price-with-discount-code";
                            priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                            priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                            priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                            const priceWithDiscountCodeEl = floatingButton.parentElement.querySelector(".price-with-discount-code");
                            if (priceWithDiscountCodeEl)
                                priceWithDiscountCodeEl === null || priceWithDiscountCodeEl === void 0 ? void 0 : priceWithDiscountCodeEl.remove();
                            priceWithDiscountCode.style.width = "100%";
                            priceWithDiscountCode.style.textAlign = "center";
                            priceWithDiscountCode.style.display = "block";
                            floatingButton.prepend(priceWithDiscountCode);
                        }
                    }
                    else {
                        this.appendChild(priceContainer);
                    }
                    break;
                case "PriceWithMarkdown":
                case "PriceWithPointsAndMarkdown":
                case "PriceWithCashbackAndMarkdown":
                    this.dataset.type = "PriceWithMarkdown";
                    if (priceObject.isKit) {
                        priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
                        priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPrice, "original-price"));
                        this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPrice, priceObject.placement);
                    }
                    else {
                        priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
                        priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
                        this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.price, priceObject.placement);
                    }
                    if (isCard) {
                        this.appendChild(priceContainer);
                    }
                    else if (isPdpDesk) {
                        this.appendChild(priceContainer);
                    }
                    else if (isPdpMob) {
                        this.appendChild(priceContainer);
                    }
                    else if (isPdk) {
                        this.appendChild(priceContainer);
                    }
                    break;
                case "PriceWithDiscountCodeAndPix":
                    this.dataset.type = "PriceWithDiscountCodeAndPix";
                    this.setDiscountFlagElement(priceObject.price, priceObject.priceWithDiscountCode, priceObject.placement);
                    if (priceObject.placement !== "card") {
                        priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
                    }
                    else {
                        priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.price));
                    }
                    priceContainer.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                    if (priceObject.placement === "card") {
                        priceContainer.appendChild(this.createPixCouponElement(priceObject.priceWithDiscountCodeAndPixDiscount));
                    }
                    if (isPdpMob) {
                        this.appendChild(priceContainer);
                        const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product__media-wrapper");
                        if (mediaWrapper) {
                            const priceWithDiscountCode = document.createElement("span");
                            priceWithDiscountCode.className = "price-with-discount-code";
                            priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                            priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                            priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                            const priceWithDiscountCodeEl = mediaWrapper.querySelector(".price-with-discount-code");
                            if (priceWithDiscountCodeEl)
                                priceWithDiscountCodeEl === null || priceWithDiscountCodeEl === void 0 ? void 0 : priceWithDiscountCodeEl.remove();
                            mediaWrapper.appendChild(priceWithDiscountCode);
                        }
                        const floatingButton = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-form__buttons-floating");
                        if (floatingButton) {
                            const priceWithDiscountCode = document.createElement("span");
                            priceWithDiscountCode.className = "price-with-discount-code";
                            priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                            priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                            priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                            const priceWithDiscountCodeEl = floatingButton.parentElement.querySelector(".price-with-discount-code");
                            if (priceWithDiscountCodeEl)
                                priceWithDiscountCodeEl === null || priceWithDiscountCodeEl === void 0 ? void 0 : priceWithDiscountCodeEl.remove();
                            priceWithDiscountCode.style.width = "100%";
                            priceWithDiscountCode.style.textAlign = "center";
                            priceWithDiscountCode.style.display = "block";
                            floatingButton.prepend(priceWithDiscountCode);
                        }
                    }
                    else {
                        priceContainer.appendChild(this.createCouponElement(priceObject.discountCode));
                        this.appendChild(priceContainer);
                    }
                    break;
                case "PriceWithMarkdownAndPix":
                case "PriceWithPointsAndMarkdownAndPix":
                case "PriceWithCashbackAndMarkdownAndPix":
                    this.dataset.type = "PriceWithMarkdownAndPix";
                    priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
                    // PRICE
                    if (priceObject.isKit) {
                        priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPrice, "original-price"));
                        this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPrice, priceObject.placement);
                    }
                    else {
                        priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
                        this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.price, priceObject.placement);
                    }
                    // PIX
                    if (priceObject.placement === "card") {
                        if (priceObject.isKit) {
                            priceContainer.appendChild(this.createPixCouponElement(priceObject.kitFinalPriceWithPixDiscount));
                        }
                        else {
                            priceContainer.appendChild(this.createPixCouponElement(priceObject.priceWithPixDiscount));
                        }
                    }
                    this.appendChild(priceContainer);
                    break;
                case "PriceWithMarkdownAndDiscountCode":
                    this.dataset.type = "PriceWithMarkdownAndDiscountCode";
                    priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
                    if (priceObject.placement !== "card" && !priceObject.isKit) {
                        priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
                    }
                    if (priceObject.isKit) {
                        if (priceObject.placement === "pdk") {
                            priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPrice, "original-price"));
                            this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPriceWithDiscountCode, priceObject.placement);
                            const priceContainerKit = this.parentElement.parentElement.querySelectorAll(".kit-item__info .price");
                            priceContainerKit.forEach((priceElement) => {
                                var _a;
                                const discountKitPriceElement = (_a = priceElement.querySelector(".discount-price")) === null || _a === void 0 ? void 0 : _a.textContent.replace("R$", "").replace(" ", "").replace(",", ".");
                                if (discountKitPriceElement) {
                                    const priceElementDiscountKitEl = priceElement.querySelector(".container-discount-kit-element");
                                    if (priceElementDiscountKitEl)
                                        priceElementDiscountKitEl === null || priceElementDiscountKitEl === void 0 ? void 0 : priceElementDiscountKitEl.remove();
                                    let discountedPrice = this.calculatePrice(Number(discountKitPriceElement) * 100, Math.abs(Number(priceObject.discountValue)));
                                    const containerDiscount = document.createElement("div");
                                    containerDiscount.classList.add("container-discount-kit-element");
                                    containerDiscount.style.color = this.dataset.messageColor || "#3d3d3d";
                                    containerDiscount.appendChild(this.createPriceElement(this.formatMoney(discountedPrice), "coupon-price"));
                                    containerDiscount.appendChild(this.createCouponElement(priceObject.discountCode));
                                    priceElement.appendChild(containerDiscount);
                                }
                            });
                        }
                        else {
                            priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPriceWithDiscountCode, "coupon-price"));
                            this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPriceWithDiscountCode, priceObject.placement);
                        }
                    }
                    else {
                        priceContainer.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                        this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.priceWithDiscountCode, priceObject.placement);
                    }
                    priceContainer.appendChild(this.createCouponElement(priceObject.discountCode));
                    if (isCard) {
                        this.appendChild(priceContainer);
                    }
                    else if (isPdpDesk) {
                        this.appendChild(priceContainer);
                    }
                    else if (isPdpMob) {
                        this.appendChild(priceContainer);
                        const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product__media-wrapper");
                        if (mediaWrapper) {
                            const priceWithDiscountCode = document.createElement("span");
                            priceWithDiscountCode.className = "price-with-discount-code";
                            priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                            priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                            priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                            const priceWithDiscountCodeEl = mediaWrapper.querySelector(".price-with-discount-code");
                            if (priceWithDiscountCodeEl)
                                priceWithDiscountCodeEl === null || priceWithDiscountCodeEl === void 0 ? void 0 : priceWithDiscountCodeEl.remove();
                            mediaWrapper.appendChild(priceWithDiscountCode);
                        }
                        const floatingButton = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-form__buttons-floating");
                        if (floatingButton) {
                            const priceWithDiscountCode = document.createElement("span");
                            priceWithDiscountCode.className = "price-with-discount-code";
                            priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                            priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                            priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                            const priceWithDiscountCodeEl = floatingButton.parentElement.querySelector(".price-with-discount-code");
                            if (priceWithDiscountCodeEl)
                                priceWithDiscountCodeEl === null || priceWithDiscountCodeEl === void 0 ? void 0 : priceWithDiscountCodeEl.remove();
                            priceWithDiscountCode.style.width = "100%";
                            priceWithDiscountCode.style.textAlign = "center";
                            priceWithDiscountCode.style.display = "block";
                            floatingButton.prepend(priceWithDiscountCode);
                        }
                    }
                    else if (isPdk) {
                        this.appendChild(priceContainer);
                    }
                    break;
                case "PriceWithMarkdownAndDiscountCodeAndPix":
                    this.dataset.type = "PriceWithMarkdownAndDiscountCodeAndPix";
                    priceContainer.appendChild(this.createPriceMarkdownElement(priceObject.compareAtPrice));
                    if (priceObject.placement !== "card" && !priceObject.isKit) {
                        priceContainer.appendChild(this.createPriceElement(priceObject.price, "original-price"));
                    }
                    // PRICE
                    if (priceObject.isKit) {
                        if (priceObject.placement === "pdk") {
                            priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPrice, "original-price"));
                            this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPriceWithDiscountCode, priceObject.placement);
                            const priceContainerKit = this.parentElement.parentElement.querySelectorAll(".kit-item__info .price");
                            priceContainerKit.forEach((priceElement) => {
                                var _a, _b;
                                const discountKitPriceElement = (_a = priceElement.querySelector(".discount-price")) === null || _a === void 0 ? void 0 : _a.textContent.replace("R$", "").replace(" ", "").replace(",", ".");
                                if (discountKitPriceElement) {
                                    (_b = priceElement.querySelector(".container-discount-kit-element")) === null || _b === void 0 ? void 0 : _b.remove();
                                    let discountedPrice = this.calculatePrice(Number(discountKitPriceElement) * 100, Math.abs(Number(priceObject.discountValue)));
                                    const containerDiscount = document.createElement("div");
                                    containerDiscount.classList.add("container-discount-kit-element");
                                    containerDiscount.style.color = this.dataset.messageColor || "#3d3d3d";
                                    containerDiscount.appendChild(this.createPriceElement(this.formatMoney(discountedPrice), "coupon-price"));
                                    containerDiscount.appendChild(this.createCouponElement(priceObject.discountCode));
                                    priceElement.appendChild(containerDiscount);
                                }
                            });
                        }
                        else {
                            priceContainer.appendChild(this.createPriceElement(priceObject.kitFinalPriceWithDiscountCode, "coupon-price"));
                            this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.kitFinalPriceWithDiscountCode, priceObject.placement);
                        }
                    }
                    else {
                        priceContainer.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                        this.setDiscountFlagElement(priceObject.compareAtPrice, priceObject.priceWithDiscountCode, priceObject.placement);
                    }
                    // PIX
                    if (priceObject.placement === "card") {
                        if (priceObject.isKit) {
                            priceContainer.appendChild(this.createPixCouponElement(priceObject.kitFinalPriceWithDiscountCodeAndPixDiscount));
                        }
                        else {
                            priceContainer.appendChild(this.createPixCouponElement(priceObject.priceWithDiscountCodeAndPixDiscount));
                        }
                    }
                    else if (priceObject.placement === "pdp-mob" && window.innerWidth < 750) {
                        const mediaWrapper = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product__media-wrapper");
                        if (mediaWrapper) {
                            const priceWithDiscountCode = document.createElement("span");
                            priceWithDiscountCode.className = "price-with-discount-code";
                            priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                            priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                            priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                            const priceWithDiscountCodeEl = mediaWrapper.querySelector(".price-with-discount-code");
                            if (priceWithDiscountCodeEl)
                                priceWithDiscountCodeEl === null || priceWithDiscountCodeEl === void 0 ? void 0 : priceWithDiscountCodeEl.remove();
                            mediaWrapper.appendChild(priceWithDiscountCode);
                        }
                        const floatingButton = this.parentElement.parentElement.parentElement.parentElement.querySelector(".product-form__buttons-floating");
                        if (floatingButton) {
                            const priceWithDiscountCode = document.createElement("span");
                            priceWithDiscountCode.className = "price-with-discount-code";
                            priceWithDiscountCode.style.color = this.dataset.messageColor || "#3d3d3d";
                            priceWithDiscountCode.appendChild(this.createPriceElement(priceObject.priceWithDiscountCode, "coupon-price"));
                            priceWithDiscountCode.appendChild(this.createCouponElement(priceObject.discountCode));
                            const priceWithDiscountCodeEl = floatingButton.parentElement.querySelector(".price-with-discount-code");
                            if (priceWithDiscountCodeEl)
                                priceWithDiscountCodeEl === null || priceWithDiscountCodeEl === void 0 ? void 0 : priceWithDiscountCodeEl.remove();
                            priceWithDiscountCode.style.width = "100%";
                            priceWithDiscountCode.style.textAlign = "center";
                            priceWithDiscountCode.style.display = "block";
                            floatingButton.prepend(priceWithDiscountCode);
                        }
                    }
                    priceContainer.appendChild(this.createCouponElement(priceObject.discountCode));
                    this.appendChild(priceContainer);
                    break;
                default:
                    console.warn("Tipo de preço não tratado:", priceObject.type);
                    break;
            }
        }
    }
    customElements.define("price-normalize", PriceNormalize);
}
